import { Box, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type SupplementsFormStore from 'modules/payroll_bundle/components/Handoffs/Supplements/Forms/store'
import { SortingHead, SortingTitle } from 'modules/payroll_bundle/components/SortingHeader'

interface Props {
  toggleSupplements?: () => void
  supplementsExpanded?: boolean
  supplementsStore?: SupplementsFormStore
  loadingEmployees?: boolean
}

const Header = ({
  toggleSupplements,
  supplementsExpanded,
  supplementsStore,
  loadingEmployees,
}: Props) => {
  const supplementsLength = (supplementsStore?.forms?.length ?? 0) > 0
  const supplementsExist = !loadingEmployees && supplementsLength

  if (toggleSupplements) {
    return (
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        width="full"
        background="grey200"
        paddingX="s16"
        paddingY="s8"
      >
        <Box alignItems="flexStart" width="s400">
          <SortingTitle title={i18n.t('common.employee')} />
        </Box>

        <Box alignItems="flexStart" flexGrow justifyContent="spaceBetween" flexDirection="row">
          <Box flexDirection="row" alignSelf="center" maxWidth={'s360'}>
            <SortingTitle title={i18n.t('payroll_bundle.supplements.title')} />
          </Box>

          {supplementsExist && (
            <Box alignItems="flexEnd">
              <Button
                onClick={() => {
                  toggleSupplements()
                }}
                type="secondary"
                iconName={supplementsExpanded ? 'chevron-up' : 'chevron-down'}
              >
                {supplementsExpanded
                  ? i18n.t('payroll_bundle.supplements.supplement_collapse_all')
                  : i18n.t('payroll_bundle.supplements.supplement_expand_all')}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    )
  }

  return (
    <SortingHead>
      <Box alignItems="center">
        <SortingTitle title={i18n.t('common.employee')} />
      </Box>
    </SortingHead>
  )
}
export default Header
